const baseStyle = {
    height: '4px',
    maxW: '52px',
    backgroundColor: 'blue.500',
};
export default {
    baseStyle,
};
